"use client";
import { Avatar, Sidebar } from 'flowbite-react';
import { useContext, useEffect, useState } from 'react';
import { FaAngleDown, FaAngleUp, FaPlay, FaUserTag } from "react-icons/fa6";
import { Link, useLocation, useMatch, useNavigate, useResolvedPath } from 'react-router-dom';
import { UserContext } from '../context';
import UserLogout from './UserLogout';
import { FaStore, FaShoppingCart } from "react-icons/fa";
import axios from 'axios';

const SidebarItem = ({ path, text }) => {
  const resolvedPath = useResolvedPath(path);
  const isActive = useMatch({ path: resolvedPath.pathname, end: true });
  const className = `flex items-center text-white hover:bg-white/10 pl-3 w-full ${isActive ? 'active' : ''}`;
  const icon = isActive ? <FaPlay className='text-white h-3' /> : '';
  return (
    <Link to={path} className={className}>
      <span className='w-2'>{icon}</span>
      <span className='ml-3'>{text}</span>
      {/* <Sidebar.Item className={className}>
        {text}
      </Sidebar.Item> */}
    </Link>
  )
}

const SidebarTemplate = () => {

  // Get User Detail from the context
  const { state, setState } = useContext(UserContext);

  const [userMenu, setUserMenu] = useState(false);
  const [allShops, setAllShops] = useState([]);
  const [selectedShop, setSelectedShop] = useState(null);
  const [reportsOpen, setReportsOpen] = useState(false);

  // user token for API request
  const token = JSON.parse(window.localStorage.getItem("auth"))?.token;

  // user Detail from local storage
  const userDetail = JSON.parse(window.localStorage.getItem("auth"))?.user;

  // Get my Page Location
  const myPath = useLocation().pathname;
  const hidden = myPath === '/login' || myPath === '/register' || myPath === '/forgotPassword' ? "hidden" : ""

  useEffect(() => {
    if (userDetail && userDetail.shopId !== undefined) {
      const fetchShopName = async () => {
        try {
          const response = await axios.get(process.env.REACT_APP_API_URL + `getShop`, {
            params: {
              shopId: userDetail?.shopId
            },
            headers: {
              Authorization: `Bearer ${token}`
            }
          });
          if (response.data) {
            const shop = response.data.name;
            setSelectedShop(shop);
          }
        } catch (error) {
          console.log(error);
        }
      }
      fetchShopName();
    }
  }, [userDetail && userDetail?.shopId])

  const handleUserMenu = () => {
    setUserMenu(prev => !prev)
  }

  return (
    <div className={` ${hidden}`}>
      <Sidebar aria-label="Sidebar with multi-level dropdown example" className='h-screen'>

        {state && state.user ? (
          <Avatar rounded size="lg" className='my-5 space-x-5'>
            <div className="space-y-1 font-medium dark:text-white">
              <div>Welcome</div>
              <div className="flex text-sm text-gray-500 dark:text-gray-400 cursor-pointer"
                onClick={handleUserMenu}>
                {state.user.name && state.user.name}
                {userMenu ? <FaAngleUp className='mt-1 ml-1' /> : <FaAngleDown className='mt-1 ml-1' />}
              </div>

              <div onClick={() => setUserMenu(prev => !prev)}
                className={`absolute ${userMenu ? "" : "hidden"} left-40  mt-9 w-24 origin-top-right rounded-md bg-white shadow-lg`}>

                {/* <Link to='/myProfile' className="flex px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" >
                  <div className='mt-1 mr-1'><FaUserTag /></div>MyProfile
                </Link> */}
                <UserLogout />
              </div>
              <div className={`flex text-[9px] text-gray-700 dark:text-gray-400 cursor-pointer ${selectedShop ? '' : 'hidden'}`}>
                <FaStore className='mt-[2px] mr-[2px] text-[9px] ' />{selectedShop && selectedShop}
                <Link to='shopSelection' className={`text-[8px] mt-[1px] underline ml-1 text-blue-800 hover:text-red-500 ${userDetail && userDetail.userRole === 'Admin' ? '' : 'hidden'}`}>change Shop</Link>
              </div>
            </div>
          </Avatar>
        ) : (
          <div className='my-5 space-x-5'>
            <h1 className='mt-16 text-center'>Pleae Login to Continue </h1>
            <h1 className='underline text-sm text-gray-500 font-medium text-center cursor-pointer dark:text-gray-400 ml-16'><Link to='/login'>Click to Login</Link></h1>
          </div>
        )}


        <Sidebar.Items className='h-[calc(100%-16rem)] py-10 rounded-lg bg-gradient-to-bl from-theme-primary to-theme-secondary' theme={{
          icon: {
            base: 'text-white'
          }
        }}>
          <Sidebar.ItemGroup>
            <div onClick={() => setReportsOpen(false)}>
              <SidebarItem path='/buying-currency' text='Buying Currency'></SidebarItem>
            </div>
            <div onClick={() => setReportsOpen(false)}>
              <SidebarItem path='/selling-currency' text='Selling Currency'></SidebarItem>
            </div>
            <div onClick={() => setReportsOpen(false)}>
              <SidebarItem path='/local-currency-balance' text='Local Currency Balance'></SidebarItem>
            </div>
            <div onClick={() => setReportsOpen(false)}>
              <SidebarItem path='/foreign-currency-balance' text='Foreign Currency Balance'></SidebarItem>
            </div>
            <div>
              <Sidebar.Item
                className="flex items-center h-6 text-white hover:bg-white/10 pl-5 w-full cursor-pointer"
                onClick={() => setReportsOpen((value) => !value)}
              >
                <span>Reports</span>
                {reportsOpen ? (
                  <FaAngleUp className="ml-16 mt-[-17px]" />
                ) : (
                  <FaAngleDown className="ml-16 mt-[-17px]" />
                )}
              </Sidebar.Item>
              {reportsOpen && (
                <div className="pl-5 mt-2">
                  <SidebarItem path="/dailyFOSReport" text="Daily FOS Report" />
                  <SidebarItem path="/dailyOpeningAndClosing" text="Daily Opening & Closing" />
                </div>
              )}
            </div>
            <div className={`${userDetail && userDetail.userRole === "Admin" ? '' : 'hidden'}`} onClick={() => setReportsOpen(false)}>
              <SidebarItem path='/settings' text='Settings'></SidebarItem>
            </div>
            {/* <Link to="/" className='hidden'>
              <Sidebar.Item href="#" icon={FaPlay} className='text-white'>
                Local Currency Balance
              </Sidebar.Item>
            </Link>
            <Link to="/" className='hidden'>
              <Sidebar.Item href="#" icon={FaPlay} className='text-white'>
                Foreign Currency Balance
              </Sidebar.Item>
            </Link>
            <Sidebar.Collapse icon={FaPlay} label="Report" className='text-white hidden'>
              <Link to="/"><Sidebar.Item href="#" className='text-white'>Buy Report</Sidebar.Item></Link>
              <Link to="/"><Sidebar.Item href="#" className='text-white'>Sell Report</Sidebar.Item></Link>
            </Sidebar.Collapse> */}
          </Sidebar.ItemGroup>
        </Sidebar.Items>
      </Sidebar>
    </div>
  );
}

export default SidebarTemplate;